// extracted by mini-css-extract-plugin
module.exports = {"basicFilter":"-multiple-select-basic-filter-basicFilter-2YL6Gp-","displayValues":"-multiple-select-basic-filter-displayValues-3rgI-n-"};